module.exports = __webpack_public_path__ + "static/img/上下料自动化产线.e0d58a37.png";